/**
 * @generated SignedSource<<6b3237d7105f630dab79a49b8f581dfe>>
 * @relayHash 78f904825b6398c52ec4849cce03c7c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec1be489f8461e0052018f718d02cf18f44a1e8f957e0a98202728987eb5100b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkforceOptimizationSettingsPageQuery } from './WorkforceOptimizationSettingsPageQuery.graphql';

const node: PreloadableConcreteRequest<WorkforceOptimizationSettingsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ec1be489f8461e0052018f718d02cf18f44a1e8f957e0a98202728987eb5100b",
    "metadata": {},
    "name": "WorkforceOptimizationSettingsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
